import {
  defaultMusicTrackId,
  musicTrackOptions,
} from "@reelmagic/domain";

export function resolveSupportedMusicTrackId(value: unknown) {
  return typeof value === "string" &&
    (musicTrackOptions.some((track) => track.id === value) || /^user-music-[a-f0-9-]{36}$/.test(value))
    ? value
    : defaultMusicTrackId;
}
